<!-- src/components/GoogleMapsWidget.vue -->
<template>
  <div v-if="isAllowed" class="w-full h-42 ">
    <iframe
      class="w-full h-full"
      :src="mapSrc"
      frameborder="0"
      style="border:0;"
      allowfullscreen=""
      loading="lazy"
      referrerpolicy="no-referrer-when-downgrade"
    ></iframe>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useCookieConsent } from '../composables/useCookieConsent';
import { useI18n } from 'vue-i18n';

const { isConsentGiven } = useCookieConsent();
const { locale } = useI18n();

// استخدم isConsentGiven.value بدلاً من isConsentGiven()
const isAllowed = computed(() => isConsentGiven.value);

const mapSrcBase = 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1357.1743466915018!2d46.739101585852005!3d24.753615381697582!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e2f038b30b55497%3A0xd8cba005ba57bd97!2sSaqer%20Al-Jazirah%20Royal%20Air%20Force%20Museum!5e0!3m2!1sen!2snl!4v1763570248983!5m2!1sen!2snl';

const mapSrc = computed(() => {
  // يمكنك تخصيص الرابط بناءً على اللغة إذا لزم الأمر
  return mapSrcBase;
});
</script>

<style scoped>
/* يمكنك إضافة تخصيصات إضافية هنا إذا لزم الأمر */
</style>
